import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { Alert, AlertTitle } from '@mui/material';
import { useLocalization } from '../../providers/LocalizationProvider';
import convertFormStateErrorToArray from './lib/convertFormStateErrorToArray';
import smoothScrollTo from './lib/smoothScrollTo';
import { useFormDebug } from './FormDebugProvider';

function FormErrorsFormState({ children, dialog = false, parentRef = null }) {
  const debug = useFormDebug();
  const { formatMessage } = useLocalization();
  const [currentErrors, setCurrentErrors] = useState(null);
  const {
    formState: { errors },
  } = useFormContext();

  const getErrors = () => {
    if (!errors) {
      return [];
    }
    try {
      if (Array.isArray(errors)) {
        return errors;
      }
      return convertFormStateErrorToArray(errors);
    } catch (err) {
      return [
        {
          message: JSON.stringify(err.message),
        },
      ];
    }
  };

  const onErrors = hasErrors => {
    // Don't scroll if form is in a dialog box
    if (!dialog) {
      if (hasErrors && parentRef.current) {
        setTimeout(() => {
          smoothScrollTo(parentRef.current, 800);
        }, 200);
      }
    }
  };

  useEffect(() => {
    const formError = getErrors();
    setCurrentErrors(formError);
    debug.add('FormErrorsFormState', formError);
    if (formError.length > 0) {
      onErrors(true);
    }
  }, [errors]);

  if (currentErrors && currentErrors?.length > 0) {
    return (
      <>
        <Alert sx={{ mb: 2, mt: -1 }} severity="error">
          <AlertTitle>
            {formatMessage({
              id: 'FORM_ERRORS',
              defaultMessage: `Errors (${currentErrors.length} issue${currentErrors.length > 1 ? 's' : ''} ${currentErrors.length > 1 ? 'have' : 'has'} to be fixed)`,
            })}
          </AlertTitle>
          <ul style={{ margin: '0 0 0 0', padding: '0 0 0 17px' }}>
            {currentErrors.map((error, index) => {
              return <li key={error?.message || index}>{error?.message}</li>;
            })}
          </ul>
        </Alert>
        {children}
      </>
    );
  }
  return children;
}

export default FormErrorsFormState;
